<template>
  <div>
    <div
      v-for="(subitem,index) in item.value.slice(0,type=='detail'?item.value.length:palette_config.show_num)"
      :key="subitem"
      class="labelItem"
      :class="{
              'active':variant_attrs[index].value == subitem,
              }"
    >
      <input
        v-model="variant_attrs[index].value"
        :id="item.name + index + subitem + (item.config[subitem]&&item.config[subitem]['variant_id'])+keys"
        :value="subitem"
        type="radio"
      />
      <label
        @mouseenter="mouse_enter&&mouse_seled(index,subitem)"
        v-if="item.config && item.config.length!=0 && ((item.palette_type == 'manual'&&(item.config[subitem].show_type=='show_image'&&item.config[subitem].image_src&&item.config[subitem].image_src!=''||item.config[subitem].show_type=='show_block'&&item.config[subitem].color_code&&item.config[subitem].color_code!=''))||(item.palette_type == 'auto_image' && item.config[subitem].default_image_src)||(item.palette_type == 'auto_block' && test_color(subitem)))"
        class="secondary_title"
        :class="[item.palette_type == 'auto_image'|| (item.palette_type == 'manual' && item.config[subitem].show_type=='show_image' )? 'right_angle':palette_config.show_style,{'main_button_boder main_button':variant_attrs[index].value == subitem}]"
        :style="{background: item.palette_type == 'auto_block' && test_color(subitem) ? 'unset':''}"
        :for="item.name + index + subitem+ (item.config[subitem]&&item.config[subitem]['variant_id'])+keys"
      >
        <div
          v-if="item.palette_type == 'manual'"
          :style="{background:item.config[subitem].show_type=='show_image'?`url(${item.config[subitem].image_src}) 0% 0% / cover`: item.config[subitem].color_code.toString().toLowerCase(),
                }"
        ></div>
        <div
          v-else-if="item.palette_type == 'auto_image'"
          style="background-size:cover"
          :style="{background:`url(${item.config[subitem].default_image_src}) 0% 0% / cover`}"
        ></div>
        <div
          v-else-if="item.palette_type == 'auto_block'"
          style="background-size:cover"
          :style="{background:subitem.toString().toLowerCase()}"
        ></div>
        <template v-else>
          <div style="text-align: center;
    line-height: 28px;margin-top: 0;">{{subitem}}</div>
        </template>
      </label>
      <template v-else>
        <label
          v-if="type=='detail'"
          class="secondary_title"
          :class="theme=='vogue'&& variant_attrs[index].value == subitem ? 'main_button' : ''"
          :for="item.name + index + subitem+ (item.config[subitem]&&item.config[subitem]['variant_id'])+keys"
        >{{ subitem }}</label>
      </template>
    </div>
    <a
      v-if="type=='card' && item.palette_type != '' && item.value.length > palette_config.show_num"
      :href="url"
    >
      <div class="labelItem2">
        <label>...</label>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: [
    "item",
    "variant_attrs",
    "type",
    "index",
    "palette_config",
    "keys",
    "theme",
    "mouse_enter"
  ],
  methods: {
    mouse_seled(index, value) {
      this.variant_attrs[index].value = value;
    },
    test_color(e) {
      const color_arr = [
        "IndianRed",
        "LightCoral",
        "Salmon",
        "DarkSalmon",
        "LightSalmon",
        "Crimson",
        "RED",
        "FireBrick",
        "DarkRed",
        "Pink",
        "LightPink",
        "HotPink",
        "DeepPink",
        "MediumVioletRed",
        "PaleVioletRed",
        "LightSalmon",
        "Coral",
        "Tomato",
        "OrangeRed",
        "DarkOrange",
        "Orange",
        "Gold",
        "Yellow",
        "LightYellow",
        "LemonChiffon",
        "LightGoldenrodYellow	",
        "PapayaWhip",
        "Moccasin",
        "PeachPuff",
        "PaleGoldenrod",
        "Khaki",
        "DarkKhaki",
        "Lavender",
        "Thistle",
        "Plum",
        "Violet",
        "Orchid",
        "Fuchsia",
        "Magenta",
        "MediumOrchid",
        "MediumPurple",
        "RebeccaPurple",
        "BlueViolet",
        "DarkViolet",
        "DarkOrchid",
        "DarkMagenta",
        "Purple",
        "Indigo",
        "SlateBlue",
        "DarkSlateBlue",
        "MediumSlateBlue",
        "GreenYellow",
        "Chartreuse",
        "LawnGreen",
        "Lime",
        "LimeGreen",
        "PaleGreen",
        "LightGreen",
        "MediumSpringGreen",
        "SpringGreen",
        "MediumSeaGreen",
        "SeaGreen",
        "ForestGreen",
        "Green",
        "DarkGreen",
        "YellowGreen",
        "OliveDrab",
        "Olive",
        "DarkOliveGreen",
        "MediumAquamarine",
        "DarkSeaGreen",
        "LightSeaGreen",
        "DarkCyan",
        "Teal",
        "Aqua",
        "Cyan",
        "LightCyan",
        "PaleTurquoise",
        "Aquamarine",
        "Turquoise",
        "MediumTurquoise",
        "DarkTurquoise",
        "CadetBlue",
        "SteelBlue",
        "LightSteelBlue",
        "PowderBlue",
        "LightBlue",
        "SkyBlue",
        "LightSkyBlue",
        "DeepSkyBlue",
        "DodgerBlue",
        "CornflowerBlue",
        "MediumSlateBlue",
        "RoyalBlue",
        "Blue",
        "MediumBlue",
        "DarkBlue",
        "Navy",
        "MidnightBlue",
        "Cornsilk",
        "BlanchedAlmond",
        "Bisque",
        "NavajoWhite",
        "Wheat",
        "BurlyWood",
        "Tan",
        "RosyBrown",
        "SandyBrown",
        "Goldenrod",
        "DarkGoldenrod",
        "Peru",
        "Chocolate",
        "SaddleBrown",
        "Sienna",
        "Brown",
        "Maroon",
        "White",
        "Snow",
        "HoneyDew",
        "MintCream",
        "Azure",
        "AliceBlue",
        "GhostWhite",
        "WhiteSmoke",
        "SeaShell",
        "Beige",
        "OldLace",
        "FloralWhite",
        "Ivory",
        "AntiqueWhite",
        "Linen",
        "LavenderBlush",
        "MistyRose",
        "Gainsboro",
        "LightGray",
        "Silver",
        "DarkGray",
        "Gray",
        "DimGray",
        "LightSlateGray",
        "SlateGray",
        "DarkSlateGray",
        "Black"
      ];
      let newArr = [];
      color_arr.forEach(element => {
        newArr.push(element.toLowerCase());
      });
      return newArr.includes(e.toString().toLowerCase());
    }
  }
};
</script>

<style  lang="scss" scoped>
</style>